export const Immigration = [
    { index: 1, id: "client.lastName", disablePadding: false, label: "Last Name" },
    { index: 2, id: "client.firstName", disablePadding: false, label: "First Name" },
    { index: 3, id: "client.middleName", disablePadding: false, label: "Middle Name" },
    { index: 4, id: "client.address", disablePadding: false, label: "Address" },
    { index: 5, id: "client.city", disablePadding: false, label: "City" },
    { index: 6, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 7, id: "type.type", disablePadding: true, label: "Type" },
    {
        index: 8,
        id: "client.birthDateString",
        orderBy: "client.birthDate",
        disablePadding: true,
        label: "Birth Date",
    },
    { index: 9, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
    { index: 10, id: "alienRegistrationNo", disablePadding: true, label: "A#" },
];

export const Taxes = [
    { index: 1, id: "client.lastName", disablePadding: false, label: "Last Name" },
    { index: 2, id: "client.firstName", disablePadding: false, label: "First Name" },
    { index: 3, id: "client.middleName", disablePadding: false, label: "Middle Name" },
    { index: 4, id: "client.address", disablePadding: false, label: "Address" },
    { index: 5, id: "client.city", disablePadding: false, label: "City" },
    { index: 6, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 7, id: "type.type", disablePadding: true, label: "Type" },
    {
        index: 8,
        id: "client.birthDateString",
        orderBy: "client.birthDate",
        disablePadding: true,
        label: "Birth Date",
    },
    { index: 9, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
];

export const Crime = [
    { index: 1, id: "client.lastName", disablePadding: false, label: "Last Name" },
    { index: 2, id: "client.firstName", disablePadding: false, label: "First Name" },
    { index: 3, id: "client.middleName", disablePadding: false, label: "Middle Name" },
    { index: 4, id: "client.address", disablePadding: false, label: "Address" },
    { index: 5, id: "client.city", disablePadding: false, label: "City" },
    { index: 6, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 7, id: "type.type", disablePadding: true, label: "Type" },
    {
        index: 8,
        id: "client.birthDateString",
        orderBy: "client.birthDate",
        disablePadding: true,
        label: "Birth Date",
    },
    { index: 9, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
];

export const Injury = [
    { index: 1, id: "client.lastName", disablePadding: false, label: "Last Name" },
    { index: 2, id: "client.firstName", disablePadding: false, label: "First Name" },
    { index: 3, id: "client.middleName", disablePadding: false, label: "Middle Name" },
    { index: 4, id: "client.address", disablePadding: false, label: "Address" },
    { index: 5, id: "client.city", disablePadding: false, label: "City" },
    { index: 6, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 7, id: "type.type", disablePadding: true, label: "Type" },
    {
        index: 8,
        id: "client.birthDateString",
        orderBy: "client.birthDate",
        disablePadding: true,
        label: "Birth Date",
    },
    { index: 9, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
];

export const Family = [
    { index: 1, id: "client.lastName", disablePadding: false, label: "Last Name" },
    { index: 2, id: "client.firstName", disablePadding: false, label: "First Name" },
    { index: 3, id: "client.middleName", disablePadding: false, label: "Middle Name" },
    { index: 4, id: "client.address", disablePadding: false, label: "Address" },
    { index: 5, id: "client.city", disablePadding: false, label: "City" },
    { index: 6, id: "fileNo", disablePadding: true, label: "File #" },
    { index: 7, id: "type.type", disablePadding: true, label: "Type" },
    {
        index: 8,
        id: "client.birthDateString",
        orderBy: "client.birthDate",
        disablePadding: true,
        label: "Birth Date",
    },
    { index: 9, id: "client.homePhone", disablePadding: true, label: "Home Phone" },
];